<template>
    <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
      <span>Items: {{ radioButtonItems }}, Value: {{ value }}</span>
      <dr-radiobuttons-component v-bind="$props" :class="evaluateClasses(classes)"></dr-radiobuttons-component>
    </dr-wrapper>
    <dr-radiobuttons-component v-else-if="isVisible" v-bind="$props" :class="evaluateClasses(classes)" @callDataSourceAction="$emit('callDataSourceAction', $event)"></dr-radiobuttons-component>
</template>

<script>
import inputMixin from '../../mixins/input-mixin'
import baseMixin from '../../mixins/base-mixin'
import inputWidgetsWrapperMixin from '../../mixins/input-widgets-wrapper-mixin'
import drRadioButtonsComponent from './dr-radiobuttons-component'

export default {
  mixins: [inputMixin, baseMixin, inputWidgetsWrapperMixin],
  components: {
    'dr-radiobuttons-component': drRadioButtonsComponent
  },
  computed: {
    radioButtonItems() {
      if (!this.getDataSourceField(this.model.Items)) {
        return ' -'
      }
      return this.getDataSourceField(this.model.Items)
    },
    value() {
      if (!this.getDataSourceField(this.model.Value)) {
        return ' -'
      }
      return this.getDataSourceField(this.model.Value)
    }
  }
}
</script>